/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserFeedbackV2Kind = (typeof FilterUserFeedbackV2Kind)[keyof typeof FilterUserFeedbackV2Kind];

export const FilterUserFeedbackV2Kind = {
  user_feedback_v2: 'user_feedback_v2',
} as const;
